module.exports = __webpack_public_path__ + "static/logo_high-01-20f95ef155baf11e5bf8abbdb8e1eb38.svg";